import {fetchCropImage, type StepPayload} from '@blesk-frontend/api';
import {cropRectToApiParams, resolveCropRect} from './resolveCropRect';

export const cropImage = (step: StepPayload): Promise<string | null> => {
  const image = step.src.edited || step.src.original;

  if (!image) return Promise.resolve(null);

  return new Promise((resolve) => {
    const img = new Image();
    img.src = image;
    img.onload = async () => {
      try {
        const imageWidth = img.naturalWidth;
        const imageHeight = img.naturalHeight;
        const rect = resolveCropRect(step, imageWidth, imageHeight);
        const {cropWidth, cropHeight, cropOffset} = cropRectToApiParams(
          rect,
          imageWidth,
          imageHeight,
        );

        const url = await fetchCropImage({
          url: image,
          cropWidth,
          cropHeight,
          cropOffset,
        });

        resolve(url);
      } catch (error) {
        console.error('Error in cropImage:', error);
        resolve(null);
      }
    };
    img.onerror = () => {
      console.error('Image loading failed.');
      resolve(null);
    };
  });
};
